"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StrategicSourcingVideo() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section id="strategic-sourcing-video" className="bg-muted py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          <div className="mx-auto mb-12 max-w-3xl text-center lg:mb-16">
            <h2 className="font-default text-3xl font-bold tracking-tight text-primary sm:text-4xl">
              The Power of Strategic Sourcing
            </h2>
          </div>

          <div className="mx-auto max-w-4xl">
            <div className="aspect-video w-full overflow-hidden rounded-lg border border-border shadow-lg">
              <iframe src="https://www.youtube-nocookie.com/embed/CjHKBd-HNhU" title="The Power of Strategic Sourcing" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen referrerPolicy="strict-origin-when-cross-origin" className="h-full w-full border-0" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}